/**
 * Single source of truth for SwissAligner wordmark size on HTML invoice/bill previews.
 * Match `.logo-image` (EasySmile-4all) so both brands share the same header footprint.
 * Keep `invoice.css` and `enforceSwissAlignerInvoiceLogoInClone` in sync with these values.
 */
export const SWISSALIGNER_INVOICE_LOGO_HEIGHT_PX = 30;
export const SWISSALIGNER_INVOICE_LOGO_MAX_WIDTH_PX = 240;
